// extracted by mini-css-extract-plugin
module.exports = {"flexItem":"style_flexItem__1m7yL","textEclips":"style_textEclips__3JYi5"};